import React from "react";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../components/CustomButtons/Button";
import DialogContent from "@mui/material/DialogContent";
import CustomInput from "../../../components/CustomInput/CustomInput";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import { Close } from "@mui/icons-material";
import { FormLabel } from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";

import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Copy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      vestigingsNaam: "",
      numberOfCopies: 1,
    };
  }

  save = () => {
    this.setState({ saving: true });

    let data = {
      vestigings_ids: this.props.vestigingIds,
      vestigings_naam: this.state.vestigingsNaam,
      number_of_copies: this.state.numberOfCopies,
    };

    axios.post("core/vestigingen/dupliceren", data).then((response) => {
      this.setState({ saving: false });
      this.props.refreshTable();
      this.props.toggle();
    });
  };

  disableSave = () => {
    return this.state.vestigingsNaam === "";
  };

  handleVestigingsNaam = (event) => {
    this.setState({ vestigingsNaam: event.target.value });
  };

  handleNumberOfCopies = (event) => {
    this.setState({ numberOfCopies: event.target.value });
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"kopieer een vestiging"} tKey={"vestigingen.modal.copy.title"} />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          <GridContainer>
            <GridItem sm={2} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper tDefault={"Vestigingennaam"} tKey={"vestigingen.modal.copy.form.naam"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={10} xs={12}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                id={"naam"}
                inputProps={{
                  type: "text",
                  name: "naam",
                  onChange: this.handleVestigingsNaam,
                }}
              />
            </GridItem>
            <GridItem sm={2} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper
                  tDefault={"Number of copies"}
                  tKey={"vestigingen.modal.copy.form.number_of_copies"}
                />
              </FormLabel>
            </GridItem>
            <GridItem sm={10} xs={12}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                id={"naam"}
                inputProps={{
                  type: "number",
                  name: "naam",
                  onChange: this.handleNumberOfCopies,
                  value: this.state.numberOfCopies,
                }}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>

        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={
              <TranslationWrapper tDefault={"Kopiëren"} tKey={"vestigingen.modal.copy.form.savebutton.text"} />
            }
            disabled={this.disableSave()}
            onClick={this.save}
            saving={this.state.saving}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(Copy, notificationsStyle);
